import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-inbuilt-datasource',
  standalone: false,
  templateUrl: './inbuilt-datasource.component.html',
  styleUrl: './inbuilt-datasource.component.scss'
})
export class InbuiltDatasourceComponent {
  @Output() selectDataSource = new EventEmitter<any>();

  @ViewChild('selectDatasourceModal') private selectDatasourceModal: any;
  @ViewChild('dsBody') private dsBody: any;
  @Input() hasDataSource: boolean = false;
  @Input() reportNameFromQueryParams: string = '';
  @Input() hasReportAdminRole: boolean = false;

  open(): void {
    this.dsBody?.resetDatasets();
    this.selectDatasourceModal?.show();
    this.dsBody?.ensureDatasourceOptionsLoaded();
  }

  onModalApply(result: { payload: any; response?: any }): void {
    this.selectDatasourceModal?.hide();
    this.selectDataSource.emit(result.payload);
  }

  onModalCancelled(): void {
    this.selectDatasourceModal?.hide();
  }
}

